import { Component, OnInit } from "@angular/core";
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";

import { CompanyMasterData } from "src/app/ui/models/domains/pbm/companies/company-master-data";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { CompanyContact } from "src/app/ui/models/domains/pbm/companies/company-contact";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { DeleteContactDialogComponent } from "../delete-contact-dialog/delete-contact-dialog.component";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { CompanyValidator } from "../validators/company-validator";
import { CompanyHandler } from "src/app/ui/models/domains/pbm/companies/company-handler";
import { CompanyMasterDataDialogComponent } from "../company-master-data-dialog/company-master-data-dialog.component";
import { LoadingService } from "src/app/ui/services/loading.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { ModalService } from "src/app/ui/services/modal.service";
import { Toast } from "../../../toast/toast";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { CompanyHandlerMasterData } from "src/app/ui/models/domains/pbm/companies/company-handler-master-data";
import { CompanyContactDialogComponent } from "../company-contact-dialog/company-contact-dialog.component";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";

@Component({
  selector: "register-company-data-quality",
  templateUrl: "./register-company-data-quality.component.html",
  styleUrls: ["./register-company-data-quality.component.scss"],
})
export class RegisterCompanyDataQualityComponent implements OnInit {
  telephoneMask = MaskInput.getTelephoneMask();
  mobileMask = MaskInput.getMobileMask();
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  zipCodeMask = MaskInput.getZipCodeMask();
  federalRegistrationMask = MaskInput.getFederalRegistrationMask();
  socialNumberMask = MaskInput.getSocialNumberMask();

  company: Company = new Company();
  companyMasterData: CompanyMasterData;

  companyMasterDataDialogRef: MatDialogRef<CompanyMasterDataDialogComponent>;


  formCompanyRegistration: FormGroup = new FormGroup({
    companyKey: new FormControl(""),
    unit: new FormControl("", Validators.required),
    companyType: new FormControl(""),
    headOfficeFiscalNumber: new FormControl("", Validators.required),
    fiscalNumber: new FormControl("", Validators.required),
    stateRegistration: new FormControl(""),
    municipalRegistration: new FormControl(""),
    corporateName: new FormControl("", Validators.required),
    tradingName: new FormControl(""),
    street: new FormControl("", Validators.required),
    number: new FormControl("", Validators.required),
    complement: new FormControl(""),
    district: new FormControl("", Validators.required),
    city: new FormControl("", Validators.required),
    region: new FormControl("", Validators.required),
    zipCode: new FormControl("", Validators.required),
    employeeCount: new FormControl(0, [Validators.required]),
    isActive: new FormControl(true),
  });

  constructor(
    private loadingService: LoadingService,
    private featureViewService: FeatureViewService,
    private companyService: CompanyService,
    private dialog: MatDialog,
    private router: Router,
    private toast: Toast,
  ) { }

  ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.CompanyRegistrationFeatureView, PageViews.CompanyPageView);
  }

  async submitCompanyData() {
    const ref = this.loadingService.beginLoading();
    const companyValidator = new CompanyValidator();
    if (companyValidator.validate(this.formCompanyRegistration).hasErrorMessages()) {
      this.toast.showWarningToast(companyValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const companyHandler = new CompanyHandler(this.formCompanyRegistration);
      const company = companyHandler.handleFormToCompany();
      try {
        const companyKey = await this.companyService.addCompany(company);
        if (!this.formCompanyRegistration.get("companyKey").value) {
          this.formCompanyRegistration.patchValue({ companyKey });
          this.company = await this.companyService.findCompanyBy(company.getFiscalNumber());
          this.toast.showSuccessToast("Empresa cadastrada com sucesso");
        } else {
          this.company = await this.companyService.findCompanyBy(company.getFiscalNumber());
          this.toast.showSuccessToast("Empresa salva com sucesso");
        }
        this.navigateToEditCompany(company.getFiscalNumber());
      } catch (error) {
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  navigateToEditCompany(fiscalNumber: string) {
    this.router.navigate([RoutePath.EditCompany, fiscalNumber.replace(/[./-]/g, "")]);
  }

  hasCompanyKey(): boolean {
    return !!this.formCompanyRegistration.get("companyKey").value;
  }

  async searchCompanyFromMDM(): Promise<any> {
    const ref = this.loadingService.beginLoading();
    if (!!this.formCompanyRegistration.get("fiscalNumber").value) {
      try {
        let fiscalNumber;
        try {
          fiscalNumber = new FiscalNumber(this.formCompanyRegistration.get("fiscalNumber").value);
        } catch (err) {
          this.toast.showWarningToast(err);
        }
        const companyMasterData = await this.companyService.searchCompanyByFicalNumberFromMDM(fiscalNumber);
        this.companyMasterDataDialogRef = this.dialog.open(CompanyMasterDataDialogComponent, {
          width: "auto",
          data: companyMasterData,
        });
        this.companyMasterDataDialogRef.componentInstance.use.subscribe((data) => {
          this.companyMasterData = data;
          const companyHandlerMasterData = new CompanyHandlerMasterData(this.formCompanyRegistration);
          const companyMasterDataHandledResult: string[] = companyHandlerMasterData.handleCompanyMasterData(companyMasterData);
          companyMasterDataHandledResult.map((item) => {
            document.getElementById(item).setAttribute("readonly", "true");
            document.getElementById(item + "Lock").removeAttribute("hidden");
          });
          this.companyMasterDataDialogRef.close();
        });
        this.loadingService.finishLoading(ref);
      } catch (httpErrorResponse) {
        this.companyMasterData = null;
        const message = "Não foi possível obter os dados da empresa a partir do CNPJ informado.";
        if (httpErrorResponse.error.Data.ErrorMessage) {
          if (httpErrorResponse.error.Data.ErrorMessage === "Company.NotFound") {
            this.toast.showWarningToast("Dados da empresa não encontrados.");
            this.loadingService.finishLoading(ref);
            this.router.navigate([RoutePath.CreateCompany], { queryParams: { f: this.formCompanyRegistration.get("fiscalNumber").value.replace(/[./-]/g, "") } });
            return;
          }
          this.toast.showWarningToast(httpErrorResponse.error.Data.ErrorMessage);
        } else {
          this.toast.showWarningToast(message);
        }
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.toast.showWarningToast("Insira um CNPJ");
      this.loadingService.finishLoading(ref);
    }
  }

  hasCompanyMasterData(): boolean {
    return !!this.companyMasterData;
  }

  isInputLocked(input: any): boolean {
    return input;
  }

  public backToSearchCompanies(): void {
    this.router.navigate([RoutePath.SearchCompany]);
  }
}
